import { render, staticRenderFns } from "./add-new-person-form.vue?vue&type=template&id=ccb7ec3a&"
import script from "./add-new-person-form.vue?vue&type=script&lang=ts&"
export * from "./add-new-person-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports